module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n          Search By\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.canAccess('branch-create')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.branchRecordWithLoadSettlementData
    },
    model: {
      value: (_vm.branchFilter),
      callback: function($$v) {
        _vm.branchFilter = $$v
      },
      expression: "branchFilter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.planType == 'group') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Collection Center ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.loadSettlementData
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Customer")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.loadSettlementDataWithCustomer
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "EMI Date"
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "change": function($event) {
        return _vm.loadSettlementData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSettlementData]
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                    Select Status\n                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "processing"
    }
  }, [_vm._v("Processing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sattlement"
    }
  }, [_vm._v("Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "complete"
    }
  }, [_vm._v("Complete")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.canAccess('bank-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Records")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('sattlement-create')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModalForclosure
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Loan ForClosure\n            ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('sattlement-create')) ? _c('button', {
    staticClass: "btn btn-warning btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModalSettlement
    }
  }, [_c('i', {
    staticClass: "fa fa-laptop"
  }), _vm._v(" Loan Settlement\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadSettlementData()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadSettlementData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSettlementData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.name) + " - " + _vm._s(row.member.code))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.alias))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.planAmount))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountPaid))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountDue))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountPaidWithSettlement))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.sattlementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.created_by.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch_ledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [(row.status !== 'approved') ? _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n              Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.settlementDetails) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "todo-list ui-sortable",
    attrs: {
      "data-widget": "todo-list"
    }
  }, [(_vm.settlementDetails.branch) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Branch Name : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.branch.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.branch_ledger) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Payment Mode : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.branch_ledger.ledger.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Name : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member code : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.code) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Alias : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.alias) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Contact Number : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.mobile) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Email : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.email) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Application Number : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.applicationNo) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan EMI Start Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.emiStartDate) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan EMI End Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.emiEndDate) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Type : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.type) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.collection_center) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Collection Center : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.collection_center.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Plan amount : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.planAmount) + "\n                        ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Paid : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountPaid) + "\n                        ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('ul', {
    staticClass: "todo-list ui-sortable",
    attrs: {
      "data-widget": "todo-list"
    }
  }, [_c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Due Without Interest : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountDueWithoutInterest) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Due : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountDue) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Installment Paid : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalInstallmentPaid) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Installment Due : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalInstallmentDue) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Pre Closing Charge Type : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.loanPreClosingChargeType) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("loanPreClosingCharge (%) : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.loanPreClosingCharge) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Reason : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.reason) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Settlement Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.sattlementDate) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Remark : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.remark) + "\n                      ")]), _vm._v(" "), (_vm.settlementDetails.created_by) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Settled By : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.created_by.name) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Paid With Settlement : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountPaidWithSettlement) + "\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Settlement Status : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.status) + "\n                      ")])])])])])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModalForclosure"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New For Closure")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update For Closure")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateForClosure() : _vm.createForClosure()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getMemberAndGroupAndAgent]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Branch\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(bra) {
    return _c('option', {
      key: bra.id,
      domProps: {
        "value": bra.id
      }
    }, [_vm._v("\n                                " + _vm._s(bra.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "input": function($event) {
        return _vm.getPreviousLoanRecord(_vm.mem.user_id, 'processingAndPending')
      }
    },
    model: {
      value: (_vm.mem),
      callback: function($$v) {
        _vm.mem = $$v
      },
      expression: "mem"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.memberloanplans.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.memberloanplans), function(mlp, id) {
    return _c('tr', {
      key: id
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.previous_member_loan_plan_id),
        expression: "form.previous_member_loan_plan_id"
      }],
      staticClass: "minimal",
      attrs: {
        "type": "radio",
        "name": "previous_member_loan_plan_id"
      },
      domProps: {
        "value": mlp.id,
        "checked": _vm._q(_vm.form.previous_member_loan_plan_id, mlp.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.form, "previous_member_loan_plan_id", mlp.id)
        }, function($event) {
          return _vm.getLoanEMI(mlp)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Application No :")]), _vm._v(" " + _vm._s(mlp.applicationNo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Name : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'name')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Type : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'planType')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Type :")]), _vm._v(" " + _vm._s(mlp.type) + " "), _c('br'), _vm._v(" "), (mlp.collection_center_id) ? _c('i', [_c('strong', [_vm._v("Group :")]), _vm._v(_vm._s(mlp.collection_center.name) + " (" + _vm._s(mlp.collection_center.centerCode) + ") "), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Branch : ")]), _vm._v(_vm._s(mlp.branch.name) + "\n                                  ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Payable Amount : ")]), _vm._v(_vm._s(mlp.totalAmt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Amount : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'loanAmount')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Disbursement Amount : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'disbursementAmount')) + " "), _c('br'), _vm._v(" "), _c('strong', {
      staticClass: "text-success"
    }, [_vm._v("Paid Amount : ")]), _vm._v(_vm._s(mlp.receivedAmt)), _c('br'), _vm._v(" "), _c('strong', {
      staticClass: "text-danger"
    }, [_vm._v("Due Amount : ")]), _vm._v(_vm._s(mlp.totalAmt - mlp.receivedAmt)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Received Penalty : ")]), _vm._v(" " + _vm._s(mlp.receivedPanulty) + "\n                                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_c('strong', [_vm._v("Disbursement : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.disbursementDate))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("First EMI : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.emiStartDate))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last EMI : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.emiEndDate)) + "\n                                  ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('p', [_c('strong', [_vm._v("EMI Details")])]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.form.previous_no_of_emi))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.previous_paid_no_of_emi))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.previous_due_no_of_emi))])])])]) : _vm._e()]), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sattlementDate),
      expression: "form.sattlementDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('sattlementDate'),
    },
    attrs: {
      "type": "date",
      "name": "sattlementDate"
    },
    domProps: {
      "value": (_vm.form.sattlementDate)
    },
    on: {
      "change": _vm.settmentDateWise,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sattlementDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "sattlementDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'remark'
      ),
    },
    attrs: {
      "type": "text",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Due Principal Amount : ")]), _vm._v(" " + _vm._s(_vm.form.previous_loan_due_principal_amt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Due Interest Amount : ")]), _vm._v(" " + _vm._s(_vm.form.previous_loan_due_interest_amt) + " "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Amount : ")]), _vm._v(" " + _vm._s(_vm.paybleAmt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Amount With Forclose Charge : ")]), _vm._v(" " + _vm._s(_vm.paybleAmtWithForCloseCharge) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payable Amount With Discount : ")]), _vm._v(" " + _vm._s(_vm.paybleAmtWithDiscount) + "\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loan_forclose_charges),
      expression: "form.loan_forclose_charges"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loan_forclose_charges'),
    },
    attrs: {
      "type": "number",
      "name": "loan_forclose_charges",
      "placeholder": "Enter For Close Charges",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.loan_forclose_charges)
    },
    on: {
      "change": _vm.getPaybleAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loan_forclose_charges", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loan_forclose_charges"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loan_interest_discount),
      expression: "form.loan_interest_discount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loan_interest_discount'),
    },
    attrs: {
      "type": "text",
      "name": "loan_interest_discount",
      "placeholder": "Write Off Interest Amount",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.loan_interest_discount)
    },
    on: {
      "change": _vm.getPaybleAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loan_interest_discount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loan_interest_discount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Ledger Account\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.payment_ledgers), function(brLedger) {
    return _c('option', {
      key: brLedger.id,
      domProps: {
        "value": brLedger.id
      }
    }, [_vm._v("\n                                " + _vm._s(brLedger.name) + " " + _vm._s(brLedger.remark) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  CREATE\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  UPDATE\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModalSettlement"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(12), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New Settlement")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update Settlement")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateSettlement() : _vm.createSettlement()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getMemberAndGroupAndAgent]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Branch\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(bra) {
    return _c('option', {
      key: bra.id,
      domProps: {
        "value": bra.id
      }
    }, [_vm._v("\n                                " + _vm._s(bra.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "input": function($event) {
        return _vm.getPreviousLoanRecord(_vm.mem.user_id, 'processingAndPending')
      }
    },
    model: {
      value: (_vm.mem),
      callback: function($$v) {
        _vm.mem = $$v
      },
      expression: "mem"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.memberloanplans.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.memberloanplans), function(mlp, id) {
    return _c('tr', {
      key: id
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.previous_member_loan_plan_id),
        expression: "form.previous_member_loan_plan_id"
      }],
      staticClass: "minimal",
      attrs: {
        "type": "radio",
        "name": "previous_member_loan_plan_id"
      },
      domProps: {
        "value": mlp.id,
        "checked": _vm._q(_vm.form.previous_member_loan_plan_id, mlp.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.form, "previous_member_loan_plan_id", mlp.id)
        }, function($event) {
          return _vm.getLoanEMI(mlp)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Application No :")]), _vm._v(" " + _vm._s(mlp.applicationNo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Name : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'name')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Type : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'planType')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Type :")]), _vm._v(" " + _vm._s(mlp.type) + " "), _c('br'), _vm._v(" "), (mlp.collection_center_id) ? _c('i', [_c('strong', [_vm._v("Group :")]), _vm._v(_vm._s(mlp.collection_center.name) + " (" + _vm._s(mlp.collection_center.centerCode) + ") "), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Branch : ")]), _vm._v(_vm._s(mlp.branch.name) + "\n                                  ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Payable Amount : ")]), _vm._v(_vm._s(mlp.totalAmt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Amount : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'loanAmount')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Disbursement Amount : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'disbursementAmount')) + " "), _c('br'), _vm._v(" "), _c('strong', {
      staticClass: "text-success"
    }, [_vm._v("Paid Amount : ")]), _vm._v(_vm._s(mlp.receivedAmt)), _c('br'), _vm._v(" "), _c('strong', {
      staticClass: "text-danger"
    }, [_vm._v("Due Amount : ")]), _vm._v(_vm._s(mlp.totalAmt - mlp.receivedAmt)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Received Penalty : ")]), _vm._v(" " + _vm._s(mlp.receivedPanulty) + "\n                                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_c('strong', [_vm._v("Disbursement : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.disbursementDate))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("First EMI : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.emiStartDate))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last EMI : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.emiEndDate)) + "\n                                  ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('p', [_c('strong', [_vm._v("EMI Details")])]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.form.previous_no_of_emi))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.previous_paid_no_of_emi))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.previous_due_no_of_emi))])])])]) : _vm._e()]), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sattlementDate),
      expression: "form.sattlementDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('sattlementDate'),
    },
    attrs: {
      "type": "date",
      "name": "sattlementDate"
    },
    domProps: {
      "value": (_vm.form.sattlementDate)
    },
    on: {
      "change": _vm.settmentDateWise,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sattlementDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "sattlementDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Reason ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reason),
      expression: "form.reason"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('reason')
    },
    attrs: {
      "name": "reason",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PrePayment"
    }
  }, [_vm._v("PrePayment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "First Payment Default"
    }
  }, [_vm._v("X01 -> First Payment Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Death"
    }
  }, [_vm._v("X02 -> Death")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Willful Default Status"
    }
  }, [_vm._v("X03 -> Willful Default Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Untagged"
    }
  }, [_vm._v("X09 -> Untagged")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Not Applicable"
    }
  }, [_vm._v("X10 -> Not Applicable")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "reason"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'remark'
      ),
    },
    attrs: {
      "type": "text",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Due Principal Amount : ")]), _vm._v(" " + _vm._s(_vm.form.previous_loan_due_principal_amt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Due Interest Amount : ")]), _vm._v(" " + _vm._s(_vm.form.previous_loan_due_interest_amt) + " "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Amount : ")]), _vm._v(" " + _vm._s(_vm.paybleAmt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Amount With Forclose Charge : ")]), _vm._v(" " + _vm._s(_vm.paybleAmtWithForCloseCharge) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payable Amount With Discount : ")]), _vm._v(" " + _vm._s(_vm.paybleAmtWithDiscount) + "\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loan_forclose_charges),
      expression: "form.loan_forclose_charges"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loan_forclose_charges'),
    },
    attrs: {
      "type": "number",
      "name": "loan_forclose_charges",
      "placeholder": "Enter For Close Charges",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.loan_forclose_charges)
    },
    on: {
      "change": _vm.getPaybleAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loan_forclose_charges", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loan_forclose_charges"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loan_interest_discount),
      expression: "form.loan_interest_discount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loan_interest_discount'),
    },
    attrs: {
      "type": "text",
      "name": "loan_interest_discount",
      "placeholder": "Write Off Interest Amount",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.loan_interest_discount)
    },
    on: {
      "change": _vm.getPaybleAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loan_interest_discount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loan_interest_discount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Ledger Account\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.payment_ledgers), function(brLedger) {
    return _c('option', {
      key: brLedger.id,
      domProps: {
        "value": brLedger.id
      }
    }, [_vm._v("\n                                " + _vm._s(brLedger.name) + " " + _vm._s(brLedger.remark) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  CREATE\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  UPDATE\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Loan Id")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("(C/O) Alias")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Mob")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Paid Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Due Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Settle Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Settle Date")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Settlement Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Select")]), _vm._v(" "), _c('th', [_vm._v("Loan Details ")]), _vm._v(" "), _c('th', [_vm._v("Payment Details")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Date")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', [_vm._v("No of EMI ")]), _vm._v(" "), _c('th', [_vm._v("Paid No of EMI")]), _vm._v(" "), _c('th', [_vm._v("Due No of EMI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("For Close Charge "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Write Off Interest Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Select")]), _vm._v(" "), _c('th', [_vm._v("Loan Details ")]), _vm._v(" "), _c('th', [_vm._v("Payment Details")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Date")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', [_vm._v("No of EMI ")]), _vm._v(" "), _c('th', [_vm._v("Paid No of EMI")]), _vm._v(" "), _c('th', [_vm._v("Due No of EMI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("For Close Charge "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Write Off Interest Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3472b7f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/entry/LoanClosure.vue
// module id = 849
// module chunks = 0